import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import OrgAuthLayout from "../OrgAuthLayout";
import curlyHairImg from "../../../assets/img/curly_hair_girl.svg";
import { Formik } from "formik";
import BaseInput from "../../base/BaseInput";
import BasePassword from "../../base/BasePassword";
import BaseButton from "../../base/BaseButton";
import {
  LoginFormValues,
  validateLoginFunction,
} from "../../../utils/validateSchema";
import { useAppDispatch } from "../../../store";
import { loginAction } from "../../../store/slices/auth/action";
import { toast } from "react-toastify";
import { Platform } from "../../../enums/plaftorm.enum";

const LoginForm = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isProcessing, setIsProcessing] = useState(false);

  const SubmitLogin = async (value: LoginFormValues) => {
    try {
      if (value) {
        const loginData = {
          ...value,
          createdFromPlatform: Platform.OrganisationDashboard,
        };
        setIsProcessing(true);
        const res = await dispatch(loginAction(loginData));
        

        if (res.payload.status === 200) {
          window.location.replace(`/dashboard`);

          setIsProcessing(false);
        }
        if (res.payload?.statusCode >= 400 && res.payload?.statusCode < 500) {
          setIsProcessing(false);
          return toast.error(res.payload?.message);
        }
        if (res.payload?.statusCode >= 500) {
          setIsProcessing(false);
          return toast.error(
            "An unexpected error has occured! please try again"
          );
        }
      }
    } catch (error) {
      setIsProcessing(false);
    }
  };

  const userObj: LoginFormValues = {
    email: "",
    password: "",
  };

  return (
    <OrgAuthLayout title="Login" bgImage={curlyHairImg}>
      <div className="w-full flex px-5 justify-center">
        <div className="flex h-fit lg:w-2/3 w-full  rounded-lg p-6 bg-white overflow-y-scroll transition">
          <div className="w-full page-bg-padding">
            <h3 className="text-[32px] font-medium text-center text-[#2D2D31]">
              Log In
            </h3>
            <p className="text-[#2D2D31] text-center">
              Log in into your account
            </p>
            <div className="transition mt-8">
              <Formik
                initialValues={userObj}
                onSubmit={SubmitLogin}
                validate={validateLoginFunction}
              >
                {(formik) => {
                  const {
                    values,
                    touched,
                    handleChange,
                    handleSubmit,
                    errors,
                    handleBlur,
                  } = formik;
                  return (
                    <form onSubmit={handleSubmit}>
                      <BaseInput
                        id={"email"}
                        value={values.email}
                        label="Email address"
                        name={"email"}
                        type="email"
                        hasError={errors.email && touched.email}
                        change={handleChange}
                        blur={handleBlur}
                        bodyStyles="mb-8"
                        errorMsg={errors.email}
                      />
                      <BasePassword
                        id={"password"}
                        label="Password"
                        value={values.password}
                        name="password"
                        styleClass="!mt-4"
                        hasError={errors.password && touched.password}
                        change={handleChange}
                        blur={handleBlur}
                        errorMsg={errors.password}
                      />
                      <div className="pt-3 pb-3 flex justify-center">
                        <p>
                          <Link to="/forgot-password">Forgot Password?</Link>
                        </p>
                      </div>
                      <BaseButton
                        text="Log In"
                        type="submit"
                        variant="primary"
                        styles="w-full mt-4"
                        processing={isProcessing}
                      />
                    </form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </OrgAuthLayout>
  );
};

export default LoginForm;
